import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

i18n.use(initReactI18next).init({
    interpolation: {
        escapeValue: false,
        prefix: '${',
        suffix: '}',
    },
});

export default i18n;
